export const isValidAmka = (amka: string): boolean => {
  if (!/^\d{11}$/.test(amka)) return false;

  const digits = amka.split("").map(Number);

  const sum = digits
    .map((digit, index) => (index % 2 === 1 ? digit * 2 : digit))
    .map((n) => (n > 9 ? n - 9 : n)) // Sum of digits if above 10
    .reduce((acc, n) => acc + n, 0);

  return sum % 10 === 0;
};

export const isValidIban = (iban: string): boolean => {
  if (!iban) return false;

  iban = iban.replace(/\s+/g, "").toUpperCase();

  // Must start with GR and be exactly 27 characters
  if (!iban.startsWith("GR") || iban.length !== 27) return false;

  // Must contain only alphanumeric characters
  if (!/^[A-Z0-9]+$/.test(iban)) return false;

  // Move first 4 characters to the end
  const rearranged = iban.slice(4) + iban.slice(0, 4);

  // Replace letters with numbers (A=10, ..., Z=35)
  const numericIban = rearranged.replace(/[A-Z]/g, (ch) =>
    (ch.charCodeAt(0) - 55).toString()
  );

  try {
    const remainder = BigInt(numericIban) % 97n;
    return remainder === 1n;
  } catch {
    return false; // Invalid BigInt (should never happen if input is clean)
  }
};

export const validateAmka = async (amka: string) => {
  return isValidAmka(amka);
};


export function validateAFM(afm: string): boolean {
  if (!afm || typeof afm !== "string") return false;

  afm = afm.trim();
  if (afm.length !== 9 || !/^\d{9}$/.test(afm)) return false;

  const checkDigit = parseInt(afm[8], 10);
  let sum = 0;

  // Weighted sum for first 8 digits
  for (let i = 0; i < 8; i++) {
    const digit = parseInt(afm[i], 10);
    sum += digit * Math.pow(2, 8 - i);
  }

  let mod = sum % 11;
  if (mod === 10) mod = 0;

  return mod === checkDigit;
}

